import TimelineTabsV2 from '../TimelineTabsV2';
import TimelineTabsCreateEngagementButtonsAsync from '../TimelineTabsCreateEngagementButtonsAsync';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import TimelineFiltersV2 from '../TimelineFiltersV2';
import { AnyCrmObjectTypePropType, AnyCrmObjectPropType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import TimelineSearchAndActionsBar from './TimelineSearchAndActionsBar';
import { ENGAGEMENTS_ACTIVITY, TimelineAuthContext } from 'crm-events-data';
import { ActivitySummarySection } from '../ActivitySummarySection';
import { useTimelineAuthContext } from 'crm-events-data';
import { CRMRecordsEngagementSummary } from '../../../constants/gates';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID, normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useTimelineSearch } from 'crm-events-data';
import TimelineErrorBoundary from 'crm-events-components/internal/error/TimelineErrorBoundary';
import ActivitySummaryError from '../ActivitySummaryError';
import { useAiAccessControls } from '../../../hooks/useAiAccessControls';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  activityTabIsSelected: PropTypes.bool.isRequired,
  betTabIsSelected: PropTypes.bool,
  defaultSelectedTab: PropTypes.string.isRequired,
  hasCommunicatePermissions: PropTypes.bool,
  isCollapsedByDefault: PropTypes.bool,
  objectType: AnyCrmObjectTypePropType.isRequired,
  onTabClick: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
  subject: AnyCrmObjectPropType,
  subjectId: PropTypes.string.isRequired
};
const TimelineControlsV2 = ({
  activityTabIsSelected,
  betTabIsSelected,
  defaultSelectedTab,
  hasCommunicatePermissions,
  isCollapsedByDefault,
  objectType,
  onTabClick,
  selectedTab,
  subject,
  subjectId
}) => {
  const {
    gates,
    user
  } = useTimelineAuthContext();
  const [isSearchInUse] = useTimelineSearch();
  const {
    data: accessControls
  } = useAiAccessControls();
  const canUseAi = useMemo(() => {
    return Boolean((accessControls === null || accessControls === void 0 ? void 0 : accessControls.getAccessControls.conversationDataEnabled) && (accessControls === null || accessControls === void 0 ? void 0 : accessControls.getAccessControls.copilotEnabled) && (accessControls === null || accessControls === void 0 ? void 0 : accessControls.getAccessControls.crmPropertiesEnabled) && (accessControls === null || accessControls === void 0 ? void 0 : accessControls.getAccessControls.generativeAiEnabled));
  }, [accessControls]);
  const isUngatedForActivitySummary = useMemo(() => {
    return gates === null || gates === void 0 ? void 0 : gates.includes(CRMRecordsEngagementSummary);
  }, [gates]);
  const hasRecordSummaryCardScope = useMemo(() => {
    var _user$scopes;
    return user === null || user === void 0 || (_user$scopes = user.scopes) === null || _user$scopes === void 0 ? void 0 : _user$scopes.includes('record-summary-cards');
  }, [user === null || user === void 0 ? void 0 : user.scopes]);
  const renderedCommunicatorButtons = useMemo(() => {
    if (betTabIsSelected || selectedTab === ENGAGEMENTS_ACTIVITY) {
      return null;
    }
    return /*#__PURE__*/_jsx(TimelineTabsCreateEngagementButtonsAsync, {
      selected: selectedTab,
      hasCommunicatePermissions: hasCommunicatePermissions
    });
  }, [betTabIsSelected, selectedTab, hasCommunicatePermissions]);
  const renderedSearchAndActionsBar = useMemo(() => {
    if (betTabIsSelected) {
      return null;
    }
    return /*#__PURE__*/_jsx(TimelineSearchAndActionsBar, {
      isCollapsedByDefault: isCollapsedByDefault
    });
  }, [betTabIsSelected, isCollapsedByDefault]);
  const renderedTabs = useMemo(() => {
    return /*#__PURE__*/_jsx(View, {
      marginInline: "400",
      children: /*#__PURE__*/_jsx(TimelineAuthContext.Consumer, {
        children: auth => {
          const scopes = auth && auth.user ? auth.user.scopes : [];
          return /*#__PURE__*/_jsx(TimelineTabsV2, {
            defaultSelected: defaultSelectedTab,
            objectType: objectType,
            onTabClick: onTabClick,
            selected: selectedTab,
            subject: subject,
            scopes: scopes
          });
        }
      })
    });
  }, [defaultSelectedTab, objectType, onTabClick, selectedTab, subject]);
  const objectTypeId = normalizeTypeId(objectType);
  const shouldShowActivitySummarySection = canUseAi && isUngatedForActivitySummary && hasRecordSummaryCardScope && selectedTab === 'ENGAGEMENTS_ACTIVITY' && [CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID].includes(objectTypeId) && !isSearchInUse;
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    "data-selenium-test": "timeline-controls",
    children: [renderedSearchAndActionsBar, renderedTabs, shouldShowActivitySummarySection && /*#__PURE__*/_jsx(TimelineErrorBoundary, {
      boundaryName: "ActivitySummarySectionError",
      ErrorComponent: ActivitySummaryError,
      shouldShowRefreshAlert: false,
      children: /*#__PURE__*/_jsx(ActivitySummarySection, {
        subjectId: subjectId,
        objectTypeId: objectTypeId
      })
    }), /*#__PURE__*/_jsxs(View, {
      paddingInline: "400",
      paddingBlockStart: activityTabIsSelected ? undefined : '400',
      children: [/*#__PURE__*/_jsx(TimelineFiltersV2, {
        activityTabIsSelected: activityTabIsSelected
      }), renderedCommunicatorButtons]
    })]
  });
};
TimelineControlsV2.propTypes = propTypes;
export default TimelineControlsV2;